var _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSessionCancelledIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4322_21296",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4322_21296)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.46634 12.1502L5.76634 11.4502L7.29967 9.91683L5.76634 8.3835L6.46634 7.6835L7.99967 9.21683L9.53301 7.6835L10.233 8.3835L8.69967 9.91683L10.233 11.4502L9.53301 12.1502L7.99967 10.6168L6.46634 12.1502ZM3.53301 14.3335C3.19967 14.3335 2.91634 14.2168 2.68301 13.9835C2.44967 13.7502 2.33301 13.4668 2.33301 13.1335V4.20016C2.33301 3.86683 2.44967 3.5835 2.68301 3.35016C2.91634 3.11683 3.19967 3.00016 3.53301 3.00016H4.46634V1.5835H5.48301V3.00016H10.533V1.5835H11.533V3.00016H12.4663C12.7997 3.00016 13.083 3.11683 13.3163 3.35016C13.5497 3.5835 13.6663 3.86683 13.6663 4.20016V13.1335C13.6663 13.4668 13.5497 13.7502 13.3163 13.9835C13.083 14.2168 12.7997 14.3335 12.4663 14.3335H3.53301ZM3.53301 13.3335H12.4663C12.5108 13.3335 12.5552 13.3113 12.5997 13.2668C12.6441 13.2224 12.6663 13.1779 12.6663 13.1335V6.86683H3.33301V13.1335C3.33301 13.1779 3.35523 13.2224 3.39967 13.2668C3.44412 13.3113 3.48856 13.3335 3.53301 13.3335Z",
    fill: "#FE6666"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSessionCancelledIcon);
export default __webpack_public_path__ + "static/media/session-cancelled-icon.6bd46b706b73ca54f5a9e70250cfb1b2.svg";
export { ForwardRef as ReactComponent };